export enum QuizPanelMode {
  VIEW = 'VIEW',
  TAKE = 'TAKE',
}
